const PropValidator = {
  color: String,
  size: [String, Number],
  weight: String,
  mirrored: Boolean
};

export { PropValidator };
